// extracted by mini-css-extract-plugin
export default {"ListBoard":"ListBoard_ListBoard__gDAJu","ItemContainer":"ListBoard_ItemContainer__GhmZJ","NoArticle":"ListBoard_NoArticle__Q6fNk","ToolDiv":"ListBoard_ToolDiv__odHFm"};